<template>
    <div>
        <b-dropdown
            class="lx-bulk-actions-dropdown mr-1"
            variant="primary"
        >
            <template v-slot:button-content>
                {{label}}
            </template>
            <b-dropdown-group
                :key="index"
                :header="bulkAction.group"
                v-for="(bulkAction, index) in bulkActions"
            >
                <b-dropdown-item-button
                    :key="index"
                    v-for="(bulkActionItem, index) in bulkAction.items"
                    @click="bulkActionItem.onClick"
                    :disabled="bulkActionItem.disabled"
                >
                    {{ bulkActionItem.label }}
                </b-dropdown-item-button>
            </b-dropdown-group>
        </b-dropdown>
        <responsive-button
            :icon="['fas', 'check-double']"
            :clickable="false"
            :responsiveness="false"
            variant="link"
        >{{ selectedCount }} selected</responsive-button>
    </div>
</template>

<script>
import groupBy from 'lodash/groupBy';
import ResponsiveButton from '../responsive-button/responsive-button.vue';

export default {
    name: 'BulkActions',
    components: {
        ResponsiveButton,
    },
    props: {
        selectedCount: {
            type: Number,
            default: 0,
        },
        bulkActionDefs: {
            type: Array,
            default: () => [],
        },
        label: {
            type: String,
            default: 'Actions'
        }
    },
    computed: {
        bulkActions() {
            const bulkActions = [];
            Object.entries(groupBy(this.bulkActionDefs, (def) => def.group)).forEach(([group, items]) => {
                bulkActions.push({
                    group,
                    items,
                })
            });
            return bulkActions;
        },
    }
}
</script>

<style lang="scss" scoped>
.lx-bulk-actions-dropdown > :deep(button) {
    user-select: none !important;
    box-shadow: none !important;
    display: flex !important;
    justify-content: space-between;
    align-items: center;
}

.lx-bulk-actions-dropdown > :deep(button:after) {
    display: inline-block;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: '';
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
}

.lx-bulk-actions-dropdown :deep(.dropdown-header) {
    text-transform: uppercase;
    font-weight: 1000;
    font-size: 1rem;
}
</style>